var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[_c('HotelInfo',{attrs:{"result":_vm.result}}),_vm._l((_vm.result.packages),function(pack){return _c('div',{key:'packageInfo'+pack.id},[_c('PackageInfo',{attrs:{"pack":pack,"currency":_vm.currency}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }